import { getStore } from "./getStore";

export function dispatchAfter(action: any, delay = 0) {
  setTimeout(() => getStore().dispatch(action), delay);
}

export async function dispatchNow(action: any) {
  return await getStore().dispatch(action);
}
